import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderUserComponent } from '../../header-user/header-user.component';
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-desktop-layout',
  imports: [RouterOutlet, HeaderUserComponent, FooterComponent],
  templateUrl: './desktop-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./desktop-layout.component.css'],
})
export class DesktopLayoutComponent {}
